import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-cloud",
  "use": "download-cloud-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"download-cloud\"><g clip-path=\"url(#download-cloud_clip0)\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.333 11.333L8 14l2.667-2.667M8 8v6\" /><path d=\"M13.92 12.06A3.333 3.333 0 0012 6h-.84A5.334 5.334 0 102 10.86\" /></g><defs><clipPath id=\"download-cloud_clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol